import propTypes from 'prop-types'
import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
// import Image from '../../assets/brand/vidita-modal.webp'

const SendFormModal = ({ closeModal, sended }) => {
  useEffect(() => {
    const htmlElement = document.documentElement
    htmlElement.style.overflow = 'hidden'

    return () => {
      htmlElement.style.overflow = 'unset'
    }
  }, [])

  return (
    <div className="PanelModal px-3" onClick={closeModal}>
      <div className="PanelModal__Card--Big" onClick={(e) => e.stopPropagation()}>
        <header>
          <button className="PanelModal__Button-Close" onClick={closeModal}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>

        <div className='d-flex flex-column flex-md-row gap-4 align-items-center align-items-md-start text-center text-md-start' style={{ padding: '25px', paddingTop: '40px'}}>
          {/* <img src={Image} height={200} alt="Reuniones Alerta" title="Reuniones Alerta" /> */}
          <div className='d-flex flex-column gap-3'>
            <span className='text-green title-2'>{sended ? 'Formulario enviado' : 'Ocurrió un error'}</span>
            <span className='text-1 fw-medium'>
              {sended ? 'Tus datos fueron correctamente enviados. En breve nos comunicaremos con vos.' : 'Ocurrió un error al enviar el formulario. Por favor, intenta nuevamente.'}
            </span>
            <button className='button-new-orange' style={{ width: 'fit-content' }} onClick={closeModal}>¡Entendido!</button>
          </div>
        </div>
      </div>
    </div>
  )
}

SendFormModal.propTypes = {
  closeModal: propTypes.func.isRequired,
  sended: propTypes.bool.isRequired
}

export default SendFormModal
